module.exports = __webpack_public_path__ + "img/Home21-Parent.c6f5860d.jpg";